module.exports = __webpack_public_path__ + "static/media/amazonClone.eec613db.png";